module.exports = __webpack_public_path__ + "assets/img/7343e973b3897202aa6daec610e8336b.png";